import { createFileRoute, Link } from '@tanstack/react-router'
import { Header } from '@/components/ui/header'
import { Button } from '@/components/ui/button'
import { ChevronRightIcon } from 'lucide-react'
import { Route as ContractRoute } from './route'

export const Route = createFileRoute('/contracts/$houseId/$flat/')({
  component: ContractPage,
})

function ContractPage() {
  const { fullName, title, address } = ContractRoute.useLoaderData()
  const params = Route.useParams()

  return (
    <>
      <Header title={'Оплата услуг домофона'} linkProps={{ to: '/' }} />
      <div className={'flex flex-col gap-6'}>
        <Section title="№ Договора" content={title} />
        <Section title="ФИО" content={fullName} />
        <Section title="Адрес" content={address} />
        <Section title="Наименование услуги" content={'Умный домофон'} />
      </div>
      <Button className={'mt-auto'} asChild>
        <Link to={'/contracts/$houseId/$flat/payment'} params={params}>
          Продолжить <ChevronRightIcon />
        </Link>
      </Button>
    </>
  )
}

interface SectionProps {
  title: string
  content: string
}

function Section(props: SectionProps) {
  return (
    <section>
      <h2 className={'text-label-foreground text-sm'}>{props.title}</h2>
      <p className={'mt-3'}>{props.content}</p>
    </section>
  )
}
